// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3StxW","icon":"SortAdornment_icon__2p-oq","up":"SortAdornment_up__2i-kp","down":"SortAdornment_down__3Qin7","active":"SortAdornment_active__182Tt"};